import { recordApi, OLD_VIDEO_URL_PREFIEX } from '../constant/Config'

const calculateOffsetMilliseconds = (recordBeginTime, timestamp) => {

    // 获取fileName最后三位数，作为小数 和 second相加
    const offsetMilliseconds = (timestamp - recordBeginTime) / 1000;

    return offsetMilliseconds;
}

const calculateOffsetMillisecondsByStr = (second, fileName) => {
    
    // 获取fileName最后三位数，作为小数 和 second相加
    const offsetMilliseconds = parseInt(fileName.slice(-3), 10) / 1000;

    return second + offsetMilliseconds;
}


const formatOldMediaUrlTemplate = (oldMediaUrlTemplate, fileName) => { 
    return oldMediaUrlTemplate.replace('{name}', fileName[0] + "." + fileName[1]);
}

const formatOldVideoUrlTemplate = (oldVideoUrlPrefix, fileName) => { 
    return oldVideoUrlPrefix + fileName[0] + "." + fileName[1];
}

/**
 * 格式化音频信令，去除无效数据，并进行数据转换
 * @param {string} audioEventData - 原始音频信令数据
 * @param {string} oldMediaUrlTemplate - 已部分格式化后的老的音频URL模板
 * @returns {JSON} 格式化后的数据 audioInfo = {second，milliseconds，type, url}
 */
export const parseAudioInfoFromEvent = (audioEventData, oldMediaUrlTemplate) => {

    const formatAudioInfo = (audioEvent, oldMediaUrlTemplate) => {

        let audioInfo = null;
        if (audioEvent) { 
            audioInfo = {
                second: audioEvent.second,
                milliseconds: calculateOffsetMillisecondsByStr(audioEvent.second, audioEvent.fileName[0]),
                type: audioEvent.type,
                url: audioEvent.url ? `${recordApi}${audioEvent.url}` : formatOldMediaUrlTemplate(oldMediaUrlTemplate, audioEvent.fileName)
            };
        }

        return audioInfo;
    }

    let audioInfo = null;

    // 遍历audioEventData
    audioEventData.forEach(eventArr => { 
        // 判断数组的长度是否大于0
        if (eventArr.length > 0) { 
            audioInfo = formatAudioInfo(eventArr[0], oldMediaUrlTemplate);
            return audioInfo;
        }
    });

    return audioInfo;
}

/**
 * 格式化视频频信令，去除无效数据，并进行数据转换
 * @param {string} videoEventData - 原始音频信令数据
 * @param {string} oldMediaUrlTemplate - 已部分格式化后的老的视频URL模板
 * @returns {Array} 格式化后的数据 videoInfos = [{second，milliseconds，type, url}]
 */
export const parseVideoInfoFromEvent = (videoEventData, oldMediaUrlTemplate) => {

    const formatVideoInfo = (videoEvent, oldMediaUrlTemplate) => {
        let videoInfo = null;
        if (videoEvent) { 
            videoInfo = {
                second: videoEvent.second,
                milliseconds: calculateOffsetMillisecondsByStr(videoEvent.second, videoEvent.fileName[0]),
                fixedMilliseconds: videoEvent.fixedMilliseconds ? videoEvent.fixedMilliseconds : null,
                userId: videoEvent.userId,
                type: videoEvent.type,
                url: videoEvent.url ? `${recordApi}${videoEvent.url}` : null
            };

            // 判断是否有视频矫正的毫秒数，如果有则矫正视频时间
            if (videoInfo.fixedMilliseconds) {
                videoInfo.milliseconds = videoInfo.milliseconds + videoInfo.fixedMilliseconds / 1000;
            }
        }
        return videoInfo;
    }

    let videoInfos = [];
    // 遍历audioEventData
    videoEventData.forEach(eventArr => { 

        // 判断数组的长度是否大于0
        if (eventArr.length > 0) { 
            videoInfos.push(formatVideoInfo(eventArr[0], oldMediaUrlTemplate));
        }
    });

    return videoInfos;
}

/**
 * 格式化音频信令，去除无效数据，并进行数据转换
 * @param {string} audioEventData - 原始音频信令数据
 * @returns {JSON} 格式化后的数据 audioInfo = {second，milliseconds，type, url}
 */
export const parseChatInfoFromEvent = (chatEventData, recordBeginTime) => {

    let chatInfoList = [];

    chatEventData.forEach(secondEventArr => {
        if (secondEventArr.length > 0) {
            secondEventArr.forEach(event => { 
                event.milliseconds = calculateOffsetMilliseconds(recordBeginTime, event.data.timestamp)
                chatInfoList.push(event)
            });
        }
    });

    return chatInfoList.sort((a, b) => a.milliseconds - b.milliseconds);
}

export const parseCursorInfoFromEvent = (cursorEventData, recordBeginTime) => { 
    let cursorInfoList = [];

    cursorEventData.forEach(event => {
        event.milliseconds = calculateOffsetMilliseconds(recordBeginTime, event.data.timestamp)
        cursorInfoList.push(event)
    });

    return cursorInfoList.sort((a, b) => a.milliseconds - b.milliseconds);
}

export const parsePresentationInfoFromEvent = (presentationEventData, recordBeginTime) => { 

    let presentationInfoList = [];

    presentationEventData.forEach(secondEventArr => {
        if (secondEventArr.length > 0) {
            secondEventArr.forEach(event => { 
                event.milliseconds = calculateOffsetMilliseconds(recordBeginTime, event.data.timestamp)
                presentationInfoList.push(event)
            });
        }
    });

    return presentationInfoList.sort((a, b) => a.milliseconds - b.milliseconds);
}

export const parseWhiteboardInfoFromEvent = (whiteboardEventData, recordBeginTime) => {

    let whiteboardInfoList = [];

    whiteboardEventData.forEach(secondEventArr => {
        if (secondEventArr.length > 0) {
            secondEventArr.forEach(event => {
                event.milliseconds = calculateOffsetMilliseconds(recordBeginTime, event.data.timestamp)
                whiteboardInfoList.push(event)
            });
        }
    });

    return whiteboardInfoList.sort((a, b) => a.milliseconds - b.milliseconds);
}
